export const setNestedValue = (obj, path, value) => {
  const keys = path.split(".");
  const lastKey = keys.pop();

  const clone = structuredClone(obj);
  let pointer = clone;
  for (let i = 0; i < keys.length; i++) {
    pointer[keys[i]] = { ...pointer[keys[i]] };
    pointer = pointer[keys[i]];
  }

  pointer[lastKey] = value;
  return clone;
};
